import * as React from 'react';
import styled from 'styled-components';
import { LabelMenuItem } from './LabelMenuItem';
import { LeadingContentMenuItem } from './LeadingContentMenuItem';
import { SeparatorMenuItem } from './SeparatorMenuItem';
import { AmorgMenuContent } from './AmorgMenuTypes';
import { TrailingContentMenuItem } from './TrailingContentMenuItem';
import { LeadingTrailingContentMenuItem } from './LeadingTrailingContentMenuItem';
import { AmorgMenuButton } from './AmorgMenuButton';
import { Flex } from '../compositeComponents/FlexHelpers';
import { colors } from '../colors/color';


export type AmorgMenuProps = {
    content?:AmorgMenuContent[],
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    onClickOutside?:(event:any)=>void,
    children?:React.ReactNode[] | React.ReactNode
}
export function AmorgMenu(props:AmorgMenuProps):JSX.Element
{
    const ref = React.useRef(null);

    React.useEffect(() => {
        const handleClickOutside = (event) => {
            if (ref.current && !ref.current.contains(event.target)) {
                props.onClickOutside && props.onClickOutside(event);
            }
        };
        document.addEventListener('click', handleClickOutside, true);
        return () => {
            document.removeEventListener('click', handleClickOutside, true);
        };
      }, [ props.onClickOutside ]);

    function handleContent(props:AmorgMenuContent, key:string)
    {
        switch(props.type){
                    
            case 'label':
                return <LabelMenuItem {...props} key={key} />
            
            case 'separator':
                return <SeparatorMenuItem {...props} key={key} />

            case 'leadingContent':
                return <LeadingContentMenuItem {...props} key={key} />

            case 'trailingContent':
                return <TrailingContentMenuItem {...props} key={key} />

            case 'leadingTrailingContent':
                return <LeadingTrailingContentMenuItem {...props} key={key} />

            default:
                throw new Error('Not implemented');
    }
    }

    return (
        <StyledMenu ref={ref} className="list-menu">
            {props.content && props.content.map((c,i) => {
                const menuItem = handleContent(c, `${i}`);
                if((c.type === 'leadingContent' || c.type === 'trailingContent' || c.type === 'leadingTrailingContent') && c.popupMenu)
                {
                    return (
                        <Flex key={i} alignItems='center'>
                            {menuItem}
                            <AmorgMenuButton content={c.popupMenu.content} icon={c.popupMenu.icon || 'navigation_context'} />
                        </Flex>
                    );
                }
                return menuItem;
            })}
            {props.children}
        </StyledMenu>
    );
}

const StyledMenu = styled.div`
    background:${colors.menu.background};
    padding: 4px;
    border-radius: 4px;
    width: 100%;
    display: flex;
    flex-direction: column;
    gap:5px;
    flex-grow: 1;
`;
